import { Box, Button, Card, CardActions, CardContent, FormControlLabel, FormGroup, Switch, TextField, Typography } from '@mui/material';
import { SaveOutlined } from "@mui/icons-material";
import styles from './UserDetails.module.css';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { se } from 'date-fns/locale';
import { isEqual } from 'lodash';

const UserDetails = ({user, saveUser, addUser, grants}) => {

  const [currentGrants, setCurrentGrants] = useState(user?.grants || []);
  const [currentName, setCurrentName] = useState(user?.name || '');
  const [nameError, setNameError] = useState(false);

  useEffect(() => {
    if(user) {
      setCurrentGrants(user.grants);
      setCurrentName(user.name);
    } 
    else {
      setCurrentGrants([]);
      setCurrentName('');
    }
    setNameError(false);
  }, [user]);

  const isAddingMode = () => !user?.id;



  const changeGrants = (e) => {
    const { value, checked } = e.target;

    setCurrentGrants(prev => {
      const index = prev.findIndex(el => el === value);
      
      if(checked && index === -1) return [...prev, value];
      else if(!checked && index !== -1) return prev.filter(el => el !== value);
      else return prev;
    });
  };

  const save = useCallback(() => {
    isAddingMode() ? addUser({name: currentName, grants: currentGrants}) : saveUser({grants: currentGrants})
  }, [currentGrants, currentName, isAddingMode]);

  const validateEmail = useCallback((value) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }, []);

  const changeUser = (e) => {
    const value = e.target.value;
    setCurrentName(value);
    setNameError(value !== '' && !validateEmail(value));
  };

  const isValid = useMemo(() => {
    
    if(!isAddingMode()) {
      return !isEqual(currentGrants, user?.grants);
    }
    else {
      return !nameError;
    }
  }, [user, grants, currentGrants, nameError]);

  const items = useMemo(() => {
    
    const data = grants?.map((item) => {
      
      const switchComponent = <Switch
                                value={item.name}
                                checked={!!currentGrants.find(el => el === item.name)}
                                onChange={changeGrants}
                              />;
      
      return <FormControlLabel
                key={item.id}
                control={switchComponent}
                label={item.desc}
                labelPlacement="start"
                slotProps={{
                  typography: {
                    variant: 'body2'
                  }
                }}
                sx={{justifyContent: 'space-between', margin: '4px 0'}}
              />
    });

    return ( 
            <>
              <TextField
                fullWidth
                size='small'
                label={user ? 'Email пользователя' : 'Введите email нового пользователя'}
                value={currentName}
                error={nameError}
                InputProps={{
                  readOnly: !isAddingMode()
                }}
                onChange={changeUser}
              />
              <FormGroup sx={{marginTop: 2}}>
                <Typography variant="subtitle2" my={1} sx={{ textAlign: 'center'}}>Разрешения пользователя в разделах кабинета менеджера</Typography>
                {data}
              </FormGroup>
            </>
    ); 
  }, [grants, user, currentGrants, currentName]);

  return (
    <div className={styles.details}>
      <div className={styles.content}>
        <Card sx={{maxHeight: '100%', display: 'flex', flexDirection: 'column'}}>
          <CardContent sx={{overflow: 'auto', display: 'flex', alignItems: 'stretch', flexDirection: 'column'}}>
              {!grants?.length && (<div className={styles.emptyMessage}>Здесь пока ничего нет</div>)}
              <Box sx={{maxHeight: '100%'}}>
                {items}
              </Box>
          </CardContent>
          <CardActions sx={{px: 2}}>
            <Button
              fullWidth
              disabled={!isValid || !currentName}
              startIcon={<SaveOutlined />}
              color='error'
              variant='contained'
              sx={{my: 1}}
              onClick={save}
            >
              {user?.name ? 'Сохранить изменения' : 'Добавить нового пользователя'}
            </Button>    
          </CardActions>
        </Card>
      </div>
    </div>    
  );
};

export default UserDetails;